<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
  </div>
  <div *ngIf="operationType != 3" class="modal-title d-flex flex-row">
    <mat-icon>person</mat-icon>
    <h2 *ngIf="operationType == 1">{{'HOST.NEW_HOST_PROFILE'|translate}}&nbsp;</h2>
    <h2 *ngIf="operationType == 2">{{'HOST.HOST_PROFILE_EDITOR'|translate}}&nbsp;</h2>
    <!-- <h2>| Step {{activeStep}}</h2> -->
  </div>
  
  <mat-dialog-content [formGroup]="hostForm">
    <mat-horizontal-stepper [style.height]="operationType == 3 ? '100px;':'380px;' " #stepper>
      <mat-step *ngIf="operationType != 3">
        <div *ngIf="!loading" class="row">
          <div class="col-6">
            <div style="justify-content: space-between;" class="d-flex flex-row label-info">
              <label style="margin-top: 0px; width: 50%;" for="hostFirstName">{{'HOST.FIRST_NAME'|translate}} *</label>
              <div *ngIf="hostFormControls.hostFirstName?.invalid && (hostFormControls.hostFirstName?.dirty || hostFormControls.hostFirstName?.touched)" class="venue-alert">
                <div class="d-flex flex-row alert-danger-content">
                  <div class="alert-danger-info" *ngIf="hostFormControls.hostFirstName?.errors?.['required']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.FNAME_REQUIRED'|translate}}">
                    <div>?</div>
                  </div>
                  <div class="alert-danger-info" *ngIf="hostFormControls.hostFirstName?.errors?.['maxlength']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.MAX_50_CHARS'|translate}}">
                    <div>?</div>
                  </div>
                </div>
              </div>
            </div>
            <input
              type="text"
              id="hostFirstName"
              name="hostFirstName"
              placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
              formControlName="hostFirstName" />
          </div>
          <div class="col-6">
            <div class="d-flex flex-row label-info justify-content-between">
              <label style="margin-top: 0px; width: 50%;" for="hostLastName">{{'HOST.LAST_NAME'|translate}} *</label>
                <div *ngIf="hostFormControls.hostLastName?.invalid && (hostFormControls.hostLastName?.dirty || hostFormControls.hostLastName?.touched)" class="venue-alert">
                  <div class="d-flex flex-row alert-danger-content">
                    <div class="alert-danger-info" *ngIf="hostFormControls.hostLastName?.errors?.['required']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.LNAME_REQUIRED'|translate}}">
                      <div>?</div>
                    </div>
                    <div class="alert-danger-info" *ngIf="hostFormControls.hostLastName?.errors?.['maxlength']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.MAX_50_CHARS'|translate}}">
                      <div>?</div>
                    </div>
                  </div>
                </div>
            </div>
            <input 
            type="text" 
            id="hostLastName" 
            name="hostLastName" 
            placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" 
            formControlName="hostLastName" />
          </div>
        </div>
        <div *ngIf="!loading" class="row mt-4">
          <div class="col-6">
            <div class="d-flex flex-row justify-content-between label-info">
              <label style="margin-top: 0px; width: 50%;" for="email">{{'HOST.EMAIL'|translate}} *</label>
              <div *ngIf="hostFormControls.email?.invalid && (hostFormControls.email?.dirty || hostFormControls.email?.touched)" class="venue-alert">
                <div class="d-flex flex-row alert-danger-content">
                  <div *ngIf="hostFormControls.email?.errors?.['required']">{{'HOST.EMAIL_IS_REQUIRED'|translate}}!
                  </div>
                  <div *ngIf="hostFormControls.email?.errors?.['pattern']">{{'HOST.INVALID_EMAIL_FORMAT'|translate}}!
                  </div>
                </div>
              </div>
            </div>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
              formControlName="email" />       
          </div>
          <div class="col-6">
            <div class="d-flex flex-row justify-content-between label-info">
              <label style="margin-top: 0px; width: 50%;" for="phone">{{'HOST.PHONE'|translate}} *</label>
              <div *ngIf="hostFormControls.phone?.invalid && (hostFormControls.phone?.dirty || hostFormControls.phone?.touched)" class="venue-alert">
                <div class="d-flex flex-row alert-danger-content">
                  <div class="alert-danger-info" *ngIf="hostFormControls.phone?.errors?.['required']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.PHONE_REQUIRED'|translate}}">
                    <div>?</div>
                  </div>
                  <div class="alert-danger-info" *ngIf="hostFormControls.phone?.errors?.['minlength'] || hostFormControls.phone?.errors?.['maxlength'] || hostFormControls.phone?.errors?.['pattern']" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.PHONE_PATTERN'|translate}}">
                    <div>?</div>
                  </div>
                </div>
              </div>
            </div>
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
              formControlName="phone" />
          </div>
        </div>
        <div *ngIf="!loading" class="row mt-4 mb-5">
          <div class="col-12">
            <!-- <div style="justify-content: space-between;" class="d-flex flex-row label-info">
              <label style="margin-top: 0px; width: 50%;" for="hosts">{{ 'VENUES.ASSIGNED_HOSTS' | translate | uppercase }}</label>
            </div>
            <input
              type="text"
              id="hosts"
              name="hosts"
              placeholder="Choose one or more"
              formArrayName="hosts"
            > -->
            <app-multi-select-venue *ngIf="operationType == 1" (shareCheckedList)="shareCheckedList($event)" [operation]="operationType"></app-multi-select-venue>
            <app-multi-select-venue *ngIf="operationType == 2"  (shareCheckedList)="shareCheckedList($event)" [checkedItems]="host.venueIds" [operation]="operationType"></app-multi-select-venue>
          </div>
        </div>
        <div *ngIf="loading" class="row info">
          <mat-spinner style="margin-top: 80px; margin-bottom: 80px;" class="api-data-spinner"></mat-spinner>
        </div>
        <div class="d-flex flex-row nav-items">
          <div style="width: 80px;" class="d-flex flex-row">
                
          </div>
          <!-- <div class="d-flex flex-row dots">
            <div style="background-color: #00ffff;" class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div> -->
          <!-- <div class="d-flex flex-row">
            <button 
              (click)="activeStep=2"
              [disabled]="hostFormControls.hostFirstName?.invalid || hostFormControls.hostLastName?.invalid "
              mat-button matStepperNext
            >
              Next
            </button><mat-icon>navigate_next</mat-icon>
          </div> -->
        </div>
        <div class="row mt-5">
          <div class="col-6">
            <button *ngIf="operationType == 1" [disabled]="hostForm.invalid || venueIDs.length==0" class="mat-bakcground-primary mat-raised-button"(click)="save()">{{'HOST.CREATE_HOST'|translate}}</button>
            <button *ngIf="operationType == 2" [disabled]="hostForm.invalid || venueIDs.length==0" class="mat-bakcground-primary mat-raised-button"(click)="save()">{{ 'SAVE_CHANGES' | translate }}</button>
           </div>
          <div class="col-6">
            <button *ngIf="operationType == 1" style="width: 234px; height: 36px;" class="mat-raised-button"(click)="close()">{{ 'CANCEL' | translate }}</button>
            <button *ngIf="operationType == 2" class="mat-raised-button"(click)="close()">{{ 'CANCEL' | translate }}</button>
          </div>
        </div>
      </mat-step>
     
      <mat-step>
        <div *ngIf="operationType == 3 && !loading">
          {{'HOST.ARE_YOU_WANT_TO_DEACTIVE_THIS_HOST'|translate}}?
        </div>      
        <div *ngIf="loading" class="row info">
          <mat-spinner style="margin-top: 80px; margin-bottom: 80px;" class="api-data-spinner"></mat-spinner>
        </div>
        <div style="margin-top: 48px; margin-bottom: 32px;" class="row">
          <div class="col-6">
            <button *ngIf="operationType == 1" [disabled]="hostForm.invalid || venueIDs.length==0" class="mat-bakcground-primary mat-raised-button"(click)="save()">{{ 'VENUES.CREATE_VENUE1' | translate }}</button>
            <button *ngIf="operationType == 2" [disabled]="hostForm.invalid || venueIDs.length==0" class="mat-bakcground-primary mat-raised-button"(click)="save()">{{ 'SAVE_CHANGES1' | translate }}</button>
            <button *ngIf="operationType == 3" style="width: 234px; height: 36px;" class="mat-bakcground-primary mat-raised-button"(click)="save()">{{'HOST.DEACTIVATE'|translate}}</button>
          </div>
          <div class="col-6">
            <button *ngIf="operationType == 1 || operationType == 3" style="width: 234px; height: 36px;" class="mat-raised-button"(click)="close()">{{ 'CANCEL' | translate }}</button>
            <button *ngIf="operationType == 2" class="mat-raised-button"(click)="close()">{{ 'CANCEL_CHANGES' | translate }}</button>
          </div>
        </div>      
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>